import Vue from "vue";
const vm = new Vue();

export const getListCategoryService = async (search, addCategory) => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + "/shop/productCatagories" , {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            params: {
                page: search.page,
                per_page: search.perPage,
                ...( ( search && search.name ) ? { search: search.name } : {} ),
                filters:{
                    type: addCategory.type,
                }
            },
            }).then( res => {
                if (!res.data.status) {
                    reject(res.data.error.message);
                }
                resolve(res.data.data)
            })
    })
}

export const getListCategoryDetails = async ( addCategoryDetails , search = null ) => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + `/shop/productCatagories/${addCategoryDetails.categoryId}/item` , {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            params: {
                page: ( search ) ? search.page : 1,
                per_page: ( search ) ? search.perPage : 1000,
                ...( ( search && search.name ) ? { search: search.name } : {} ),
                filters:{
                    type: addCategoryDetails.type,
                }
            },
            }).then( res => {
                if (!res.data.status) {
                    reject(res.data.error.message);
                }
                resolve(res.data.data)
            })
    })
}

export const getCategoryDetail = async (categoryId) => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + `/shop/productCatagories/${categoryId}` , {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            }).then( res => {
                if (!res.data.status) {
                    reject(res.data.error.message);
                }
                resolve(res.data.data)
            })
    })
}

export const createCategoryService = async (addCategory) => {
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append('name', addCategory.name);
        formData.append('type', addCategory.type);

        if( addCategory.image.file != null ){
            formData.append('image', addCategory.image.file);
        }
       
        vm.$http.post( vm.$API_URL + "/shop/productCatagories",
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                Token: localStorage.getItem("access_token"),
            },
        }
            )
        .then((res) => {
          let data = res.data.data;
          if (!res.data.status) {
            reject(res.data.error.message);
          }
          resolve(data);
        });
    });
};

export const updateCategoryDetail = async (addCategory) => {
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append('name', addCategory.name);
        formData.append('type', addCategory.type);
        
        if( addCategory.image.file != null ){
            formData.append('image', addCategory.image.file);
        }
        
        formData.append('_method', 'PUT')
        
        vm.$http.post( vm.$API_URL + `/shop/productCatagories/${addCategory.categoryId}`, 
            formData,
            {
                headers: { 
                    'Content-Type': 'multipart/form-data',
                    Token: localStorage.getItem("access_token") 
                }
            }
        )
        .then((res) => {
            let data = res.data.data;
            if (!res.data.status) {   
                reject(res.data.error.msg);
            }
            resolve(data);
        });
    });
};

export const getServiceDetail = async (addService) => {
    return new Promise((resolve, reject) => {
        vm.$http.get( vm.$API_URL + `/shop/productCatagories/${addService.categoryId}/item/${addService.serviceId}` , {
            headers: {
                Token: localStorage.getItem("access_token")
            },
            }).then( res => {
                if (!res.data.status) {
                    reject(res.data.error.message);
                }
                resolve(res.data.data)
            })
    })
}

export const createService = async (addService) => {
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append('name', addService.name);
        formData.append('rate', addService.rate);
        formData.append('fee', ( addService.fee ) ? addService.fee : 0 );

        if( addService.image.file != null ){
            formData.append('image', addService.image.file);
        }
        
        vm.$http.post( vm.$API_URL + `/shop/productCatagories/${addService.categoryId}/item`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Token: localStorage.getItem("access_token"),
                },
            }
        )
        .then((res) => {
          let data = res.data.data;
          if (!res.data.status) {
            reject(res.data.error.message);
          }
          resolve(data);
        });
    });
};

export const updateService = async (addService) => {
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append('name', addService.name);
        formData.append('rate', addService.rate);
        formData.append('fee', ( addService.fee ) ? addService.fee : 0 );
        formData.append('product_category_id', addService.categoryId );

        if( addService.image.file != null ){
            formData.append('image', addService.image.file);
        }

        formData.append('_method', 'PUT')

        vm.$http
        .post( vm.$API_URL + `/shop/productCatagories/${addService.categoryIdDefault}/item/${addService.serviceId}`, 
            formData,
            {
                headers: { 
                    'Content-Type': 'multipart/form-data',
                    Token: localStorage.getItem("access_token") 
                }
            }
        )
        .then((res) => {
            let data = res.data.data;
            if (!res.data.status) {   
                reject(res.data.error.msg);
            }
            resolve(data);
        });
    });
};

export const deleteCategory = async ( addCategory ) => {
    return new Promise((resolve, reject) => {
        vm.$http
          .delete(vm.$API_URL + `/shop/productCatagories/${addCategory.categoryId}`, {
              headers: {
                  Token: localStorage.getItem("access_token"),
              }
          })
          .then((res) => {
              let data = res.data.data;
              if (!res.data.status) {
                  reject(res.data.error.message);
              }
              resolve(data);
          });
    });
};

export const deleteService = async ( addService ) => {
    return new Promise((resolve, reject) => {
      vm.$http
        .delete(vm.$API_URL + `/shop/productCatagories/${addService.categoryId}/item/${addService.serviceId}`, {
            headers: {
                Token: localStorage.getItem("access_token"),
            }
        })
        .then((res) => {
            let data = res.data.data;
            if (!res.data.status) {
                reject(res.data.error.message);
            }
            resolve(data);
        });
    });
};
  